import {
  PokemonType,
  SkillData,
  SkillType,
  SkillRangeType,
  StatusEffect,
  SkillEvent_Global,
} from "types/battle-engine/battle";
import { parseSkillIdToName } from "../utils/parse-id-to-name";
import { msToTicks } from "../utils/ms-to-ticks";

// Global Buff/Debuff Skills
export const [
  LEER,
  GROWL,
  SCARY_FACE,
  SUNNY_DAY,
  // WATER_SPORT,
  // FOREST_CURSE,
  // MAGNETIC_FLUX,
  // HAIL,
  // COACHING_MAX,
  // MUD_SPORT,
  // FEATHER_DANCE,
  // HEAL_BLOCK,
  // QUIVER_DANCE,
  // GRUDGE,
  // DRAGON_CHEER,
  // EMBARGO,
  // FLOWER_BLESSING,
]: SkillData[] = [
  {
    id: "leer",
    description: "Lowers the defense of all enemies.",
    pokemon_type: PokemonType.NORMAL,
    type: SkillType.DEBUFF,
    status: StatusEffect.DEFENSE_DOWN,
    cooldown_ticks: 450,
    probability: 1,
  },
  {
    id: "growl",
    description: "Increases the attack of all allies.",
    starts_active: false,
    pokemon_type: PokemonType.NORMAL,
    type: SkillType.BUFF,
    status: StatusEffect.ATTACK_UP,
    status_intensity: 2,
    status_duration_ticks: msToTicks(8000),
    cooldown_ticks: msToTicks(12000),
    additional_vfx: [
      {
        sprite_path: "/assets/spells/vfx/paw_status_000__6.png",
        sprite_scale: 1.5,
        sprite_alpha: 1,
        speed: 0.2,
        anchor_to_target: true,
        y_offset: -60,
      },
    ],
    probability: 1,
  },
  {
    id: "scary-face",
    description: "Intimidates all enemies, causing fear.",
    pokemon_type: PokemonType.NORMAL,
    type: SkillType.DEBUFF,
    status: StatusEffect.FEAR,
    cooldown_ticks: msToTicks(5000),
    additional_vfx: [
      {
        sprite_path: "/assets/spells/vfx/scary_face_000__18.png",
        sprite_scale: 1.5,
        sprite_alpha: 1,
        speed: 0.2,
        anchor_to_target: true,
        y_offset: -60,
      },
      {
        sprite_path: "/assets/spells/vfx/scary_face_001__9.png",
        sprite_scale: 1.5,
        sprite_alpha: 1,
        speed: 0.2,
        anchor_to_target: true,
        y_offset: -60,
      },
    ],
    probability: 1,
  },
  {
    id: "sunny-day",
    starts_active: false,
    description: "Increases attack of the team.",
    pokemon_type: PokemonType.FIRE,
    type: SkillType.BUFF,
    status: StatusEffect.ATTACK_UP,
    cooldown_ticks: msToTicks(12000),
    status_duration_ticks: msToTicks(6000),
    additional_vfx: [
      {
        sprite_path: "/assets/spells/vfx/sunny-day.png",
        sprite_scale: 0.75,
        sprite_alpha: 1,
        speed: 0.2,
        anchor_to_target: true,
        y_offset: -75,
      },
    ],

    probability: 1,
  },
].map((skill) => ({
  id: skill.id,
  event_checks:
    "event_checks" in skill
      ? (skill.event_checks as SkillData["event_checks"])
      : undefined,
  momentum:
    "momentum" in skill ? (skill.momentum as SkillData["momentum"]) : undefined,
  team_conditions:
    "team_conditions" in skill
      ? (skill.team_conditions as SkillData["team_conditions"])
      : undefined,
  starts_active:
    "starts_active" in skill ? (skill.starts_active as boolean) : undefined,
  name: parseSkillIdToName(skill.id),
  description: skill.description || "",
  power: 0,
  pokemon_type: skill.pokemon_type,
  types: [skill.type],
  cooldown_ticks: skill.cooldown_ticks,
  mana_cost: 10,
  range: {
    type:
      skill.type == SkillType.DEBUFF
        ? SkillRangeType.ALL_ENEMIES
        : SkillRangeType.ALL_ALLIES,
    value: 99,
  },

  charging: {
    is_required: true,
    align_to: "target",
    anim_on_end: {
      name: "rotate",
      dir: "south",
    },
    duration_ticks: 60,
    is_channel: true,
  },

  on_hit: [],
  on_cast: [
    {
      __typename: "Global",
      duration_ticks: 35,
      target: {
        type: skill.type == SkillType.DEBUFF ? "enemy" : "ally",
        id: 0,
      },
      status_effects: [
        {
          status: skill.status,
          duration_ticks: skill.status_duration_ticks ?? msToTicks(3500),
          intensity: skill.status_intensity ?? 1,
        },
      ],
      starting_tick: 0,
      vfx: {
        sprite_path: "/assets/spells/vfx/stars_effect_001__40.png",
        sprite_scale: 1,
        sprite_alpha: 1,
        speed: 0.5,
        anchor_to_target: true,
      },
      blocks_event_pipeline: false,
      probability: skill.probability,
      event_check: "event_check" in skill ? skill.event_check : undefined,
    } as SkillEvent_Global,
    ...(skill.additional_vfx ?? []).map(
      (vfx) =>
        ({
          __typename: "Global",
          duration_ticks: 35,
          target: {
            type: skill.type == SkillType.DEBUFF ? "enemy" : "ally",
            id: 0,
          },
          status_effects: [],
          starting_tick: 0,
          vfx: {
            sprite_path: vfx.sprite_path,
            sprite_scale: vfx.sprite_scale,
            sprite_alpha: vfx.sprite_alpha,
            speed: vfx.speed,
            anchor_to_target: vfx.anchor_to_target,
            y_offset: vfx.y_offset,
          },
          blocks_event_pipeline: false,
        }) as SkillEvent_Global,
    ),
  ],
}));
